import React from 'react';
import styles from './Loading.module.less';
import loading from '../../static/loading.gif';

export default function Loading({ styleType }) {
  if (styleType && styleType === 'black') {
    return (
      <div className={styles.loading_b}>
        <div className={styles.loading_b_bg}>
          <div className={styles.loading_b_img}></div>
        </div>
      </div>
    );
  }
  return (
    <div className={styles.loading}>
      <img className={styles.loading_img} src={loading} alt="" />
    </div>
  );
}
